/**
 * Scroll reveal for main sections, back-to-top control.
 * Skips work when prefers-reduced-motion: reduce.
 */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal() {
    if (reduceMotion.matches) return;

    const main = document.getElementById('MainContent');
    if (!main) return;

    const sections = main.querySelectorAll('.shopify-section:not(:first-of-type)');
    let index = 0;
    sections.forEach(function (el) {
      if (
        el.querySelector('marquee-component') ||
        el.id.indexOf('section_Fbm6Tm') !== -1 ||
        el.id.indexOf('marquee_rawz8Q') !== -1
      ) {
        return;
      }
      el.classList.add('aurum-reveal');
      el.style.setProperty('--aurum-reveal-delay', Math.min(index * 45, 180) + 'ms');
      index += 1;
    });

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('aurum-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );

    sections.forEach(function (el) {
      io.observe(el);
    });
  }

  function initBackToTop() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aurum-back-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);

    function onScroll() {
      const y = window.scrollY || document.documentElement.scrollTop;
      if (y > 380) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }

    btn.addEventListener('click', function () {
      if (reduceMotion.matches) {
        window.scrollTo(0, 0);
        return;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initPressMarquee() {
    var marquees = document.querySelectorAll('marquee-component');
    marquees.forEach(function (el) {
      el.removeAttribute('data-disabled');

      function kick() {
        el.style.setProperty('--marquee-speed', el.style.getPropertyValue('--marquee-speed') || '38s');

        var wrapper = el.querySelector('.marquee__wrapper');
        if (!wrapper) return;

        var direction = getComputedStyle(el).getPropertyValue('--marquee-direction').trim() || 'normal';
        var speed = el.style.getPropertyValue('--marquee-speed') || '38s';
        wrapper.style.animation = 'none';
        void wrapper.offsetWidth;
        wrapper.style.animation =
          'marquee-motion ' + speed + ' linear infinite ' + direction;
      }

      if (customElements.get('marquee-component')) {
        customElements.whenDefined('marquee-component').then(kick);
      } else {
        kick();
      }

      setTimeout(kick, 300);
      setTimeout(kick, 1200);
      window.addEventListener('load', kick, { once: true });
    });
  }

  function boot() {
    initReveal();
    initBackToTop();
    initPressMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
